import React from 'react';
import { Row, Col, Space, Card, Typography, Table } from "antd";
import Plot from 'react-plotly.js';
import SurfacePlot3d from "./SurfacePlot3d";
import Simulations3dSurface from "./Simulations3dSurface";
import SimulationView from "./SimulationView";


const { Title, Text } = Typography;



const CopulaView = ({ data }) => {
    console.log(data);
    const { info, heat_matrix, simulations, surface_vectors, tail_matrix } = data;

    const renderHeatmap = (matrix, colorscale='Viridis') => {
        const n = Math.sqrt(matrix.length);
        const z = Array(n).fill().map(() => Array(n).fill(0));
        const text = Array(n).fill().map(() => Array(n).fill(''));

        const x = Array(n).fill().map((_, i) => matrix[i * n].x.toUpperCase());
        const y = Array(n).fill().map((_, i) => matrix[i].y.toUpperCase());

        matrix.forEach((cell, index) => {
            const i = Math.floor(index / n);
            const j = index % n;
            z[i][j] = cell.value;
            text[i][j] = `${(cell.value * 100).toFixed(1)}%`; // Format value as percentage with 1 decimal place


        });

        return (
            <Plot
                data={[{
                    z,
                    x,
                    y,
                    type: 'heatmap',
                    colorscale,
                }]}
                layout={{
                    width: '100%',
                    height: '100%',
                    autosize: true,
                    xaxis: { title: 'Assets' },
                    yaxis: { title: 'Assets' },
                    annotations: text.map((row, i) =>
                    row.map((value, j) => ({
                        x: x[j],
                        y: y[i],
                        text: value,
                        showarrow: false,
                        font: {
                            color: 'white',  // Adjust for better visibility
                            size: 10,
                        }
                    }))
                ).flat(),  // Flatten to provide annotations for each cell

                }}
                config={{ displayModeBar: false }}  // Hide the toolbar

            />
        );
    };

    const renderDetailsTable = () => {
        const columns = [
            { title: 'Property', dataIndex: 'property', key: 'property' },
            { title: 'Value', dataIndex: 'value', key: 'value' },
        ];

        const data = [
            { key: 1, property: 'Number of Assets', value: info.n_assets },
            { key: 2, property: 'Number of Observations', value: info.n_obs },
            { key: 3, property: 'Start Date', value: info.start_date },
            { key: 4, property: 'End Date', value: info.end_date },
            { key: 5, property: 'Copula Type', value: info.copula_type },
        ];

        return <Table columns={columns} dataSource={data} pagination={false} />;
    };

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Row gutter={[16, 16]}>
                <Col span={8}>
                    <Card title="Model Details">
                        {renderDetailsTable()}
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs={24} xl={12}>
                        {renderHeatmap(heat_matrix, 'YlGnBu')}
                </Col>
                <Col xs={24} xl={12}>
                        {renderHeatmap(tail_matrix, 'Hot')}
                </Col>
                <Col xs={24} xxl={12}>
                    <SurfacePlot3d surfaceVectors={surface_vectors} labels={info.asset_names} />
                </Col>
                <Col xs={24} xxl={12}>
                    <Simulations3dSurface simulations={simulations} assetNames={info?.asset_names} />
                </Col>
            </Row>
            <SimulationView simulations={simulations} assetNames={info.asset_names} />
        </Space>
    );
};

export default CopulaView;